import { ObGrid } from '@outbound-ai/ursa'
import { apiPaths } from 'configs/apiConfigs'
import { ClaimsEOBStatusEnum, IClaim } from 'features/claims/types'
import { useEffect, useState } from 'react'
import { FaInfoCircle, FaRegClock } from 'react-icons/fa'
import styled from 'styled-components'
import { httpClaims } from 'utils/http'
import { EOBColumnConfig } from './EOBColumnConfig'
import { EOBNotRequested } from './EOBStatus/EOBNotRequested'

interface IClaimDetailEOBProps {
  claim: IClaim
  ClaimEOBStatus: ClaimsEOBStatusEnum
  EOBRequest: string
  anyEobReceived: boolean
}

export const ClaimsEOB = ({ claim, ClaimEOBStatus }: IClaimDetailEOBProps) => {
  const [EOBReceived, SetEOBReceived] = useState<undefined | []>()

  useEffect(() => {
    if (claim) {
      httpClaims(apiPaths.claimEOBReceived(claim.oaiClaimId)).then((res) => {
        if (res.data) {
          const filteredRecords = res.data.filter((eob: any) => eob.fileName !== '')
          SetEOBReceived(filteredRecords)
        } else {
          SetEOBReceived([])
        }
      })
    }
  }, [claim, SetEOBReceived])

  function onGridReady(params: any): Promise<void> {
    console.log(params)
    return Promise.resolve()
  }

  const eobNoRecords = () => {
    return <EOBNotRequested />
  }

  return (
    <Div>
      {ClaimEOBStatus! === ClaimsEOBStatusEnum.requestedNotReceivedOnTime && (
        <>
          {' '}
          <EOBAlert>
            <div className="left">
              <FaInfoCircle /> Requested EOB has not been received.
            </div>
          </EOBAlert>
          {/*<EOBStatus>
            <Badge fill="transparent" variant="tag">
              0
            </Badge>{' '}
            <div>Explanation of Benefits file received</div>
      </EOBStatus>*/}
        </>
      )}
      {ClaimEOBStatus! === ClaimsEOBStatusEnum.requested && (
        <>
          <EOBAlertWarning>
            <div className="left">
              <FaRegClock /> Requested EOB Pending Delivery.
            </div>
          </EOBAlertWarning>
        </>
      )}
      {ClaimEOBStatus! === ClaimsEOBStatusEnum.RequestedButBatchNotComplete && (
        <>
          <EOBAlertWarning>
            <div className="left">
              <FaRegClock /> Pending completion of AutoCheck to estimate time of arrival
            </div>
          </EOBAlertWarning>
        </>
      )}

      {/* {EOBReceived && !anyEobReceived && ClaimEOBStatus! === ClaimsEOBStatusEnum.notRequested && <EOBNotRequested />} */}

      <>
        {/*<EOBStatus>
          <Badge fill="transparent" variant="tag">
            {EOBReceived.length}
          </Badge>{' '}
          <div>Explanation of Benefits file received</div>
      </EOBStatus>*/}
        <ObGrid
          reactiveCustomComponents={true}
          columnDefs={EOBColumnConfig as any}
          onGridReady={onGridReady as any}
          rowData={EOBReceived!}
          noRowsOverlayComponent={eobNoRecords}
          rowHeight={50}
          pagination={false}
        />
      </>
    </Div>
  )
}

const Div = styled.div`
  height: 100px;
  min-height: 200px;
  width: 100%;
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`

{
  /*const EOBStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 20px 0px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  margin: 20px 0px;
  div {
    ${({ theme }) => theme.typography.h6.medium};
    color: ${({ theme }) => theme.colors.neutral.neutral};
  }
`*/
}

const EOBAlert = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: ${({ theme }) => theme.spacing.xs};
  border: 1px solid ${({ theme }) => theme.colors.grey.lighter};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.neutral.lightest};
  margin: 20px 0px;
  color: ${({ theme }) => theme.colors.grey.darker};

  .left {
    ${({ theme }) => theme.typography.s.medium};
    svg {
      color: ${({ theme }) => theme.colors.grey.light};
      margin-right: 5px;
      margin-top: -2px;
    }
  }
  .right {
    ${({ theme }) => theme.typography.xs.normal};
  }
`

const EOBAlertWarning = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  padding: ${({ theme }) => theme.spacing.xs};
  border: 1px solid ${({ theme }) => theme.colors.warning.lighter};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.warning.lightest};
  margin: 20px 0px;
  color: ${({ theme }) => theme.colors.warning.darker};
  .left {
    ${({ theme }) => theme.typography.s.medium};
    svg {
      margin-right: 5px;
      margin-top: -2px;
    }
  }
  .right {
    ${({ theme }) => theme.typography.xs.normal};
    display: flex;
    align-items: center;
    gap: 3px;
  }
`
